import { useMutation } from "@tanstack/react-query";
import { updateLlmSettings } from "../api/onboardingApi";
import { showErrorFromMutation, showSuccess } from "@/shared/utils/toast";

export const useUpdateLlmSettings = () => {
  return useMutation({
    mutationFn: updateLlmSettings,
    onSuccess: () => {
      showSuccess("AI setup saved successfully!");
    },
    onError: (error) => {
      showErrorFromMutation(error, "Failed to save AI configuration.");
    },
  });
};
